// import * as XLSX from "xlsx-js-style";
// import { saveAs } from "file-saver";
// import moment from "moment-timezone";

// // --- HELPERS ---
// // 1. FIX: Changed output from "Hh Mm" to "HH:MM" format
// const secondsToHHMM = (seconds) => {
//   if (!seconds || isNaN(seconds)) return "00:00";
//   const h = Math.floor(seconds / 3600);
//   const m = Math.floor((seconds % 3600) / 60);
//   return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
// };

// const formatToHHMM = (totalMinutes) => {
//   if (!totalMinutes || isNaN(totalMinutes)) return "00:00";
//   const h = Math.floor(totalMinutes / 60);
//   const m = Math.floor(totalMinutes % 60);
//   return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
// };

// export const ExportSupportTeamExcel = (
//   dataToExport,
//   dateRange,
//   table3Data = [],
// ) => {
//   if (!dataToExport || dataToExport.length === 0) {
//     alert("No data available to export.");
//     return;
//   }

//   // --- DYNAMIC DATE FORMATTING ---
//   let reportDateDisplay = moment().format("DD.MM.YYYY");

//   if (dateRange && dateRange.startDate && dateRange.endDate) {
//     const startStr = moment(dateRange.startDate).format("DD.MM.YYYY");
//     const endStr = moment(dateRange.endDate).format("DD.MM.YYYY");

//     if (startStr === endStr) {
//       reportDateDisplay = startStr;
//     } else {
//       reportDateDisplay = `${startStr} to ${endStr}`;
//     }
//   }

//   // ==============================================================
//   // 1. DATA PREPARATION FOR TABLE 1 (Project & Development Status)
//   // ==============================================================
//   const completedData = dataToExport.filter((row) => {
//     const status = row.Status ? row.Status.trim().toLowerCase() : "";
//     return status === "complete" || status === "completed" ;
//   });

//   const groupedByStaff = {};
//   let grandTotalEst = 0;
//   let grandTotalTaken = 0;

//   completedData.forEach((row) => {
//     const staff =
//       row.AssigneeName && row.AssigneeName.trim() !== ""
//         ? row.AssigneeName
//         : "Unassigned";
//     if (!groupedByStaff[staff]) groupedByStaff[staff] = [];

//     groupedByStaff[staff].push(row);
//     grandTotalEst += Number(row.EstimateTime) || 0;
//     grandTotalTaken += Number(row.TimeTaken) || 0;
//   });

//   // ==============================================================
//   // 2. DATA PREPARATION FOR TABLE 2 (Client Support & Complaints)
//   // ==============================================================
//   const groupedByClient = {};
//   dataToExport.forEach((row) => {
//     if (row.isManuallyRaised) {
//       const client = row.ClientName || row.ProjectName || "Unassigned";
//       if (!groupedByClient[client]) groupedByClient[client] = [];
//       groupedByClient[client].push(row);
//     }
//   });

//   // ==============================================================
//   // 3. BUILD THE EXCEL ROWS, MERGES, AND DYNAMIC HEIGHTS (8 Columns max)
//   // ==============================================================
//   const titleRow1 = [
//     "",
//     "Project & Development Status",
//     "",
//     "",
//     "",
//     "",
//     "",
//     "",
//   ];
//   const titleRow2 = ["", "Report Date:", reportDateDisplay, "", "", "", "", ""];
//   const emptyRow = ["", "", "", "", "", "", "", ""];
//   const headers1 = [
//     "",
//     "Project / Client",
//     "Module / Menu",
//     "Assigned Staff",
//     "Estimate Time",
//     "Comp. Time",
//     "Reason",
//     "",
//   ];

//   const dataRows = [];
//   const summaryRowIndices = [];
//   const merges = [
//     { s: { r: 0, c: 1 }, e: { r: 0, c: 7 } }, // Main Title Merge
//     { s: { r: 3, c: 6 }, e: { r: 3, c: 7 } }, // Table 1 Header Reason Merge (G & H)
//   ];

//   const rowHeights = [
//     { hpt: 35 }, // Main Title
//     { hpt: 20 }, // Date
//     { hpt: 10 }, // Empty
//     { hpt: 25 }, // Headers
//   ];

//   let currentRowIndex = 4; // Data starts at index 4

//   // --- BUILD TABLE 1 ROWS ---
//   Object.keys(groupedByStaff)
//     .sort()
//     .forEach((staffName) => {
//       let staffTotalEstimate = 0;
//       let staffTotalTaken = 0;

//       groupedByStaff[staffName].forEach((row) => {
//         staffTotalEstimate += Number(row.EstimateTime) || 0;
//         staffTotalTaken += Number(row.TimeTaken) || 0;
//         const reasonText = row.Description || row.Solution || "-";

//         dataRows.push([
//           "", // Col A (Spacer)
//           row.ClientName || row.ProjectName || "-",
//           row.MainMenuName || "-",
//           row.AssigneeName || "-",
//           row.EstimateTime ? formatToHHMM(row.EstimateTime) : "-",
//           row.TimeTaken ? secondsToHHMM(row.TimeTaken) : "-", // Changed to HH:MM helper
//           reasonText,
//           "", // Col H (Merged)
//         ]);

//         const lines = Math.ceil(reasonText.length / 45);
//         rowHeights.push({ hpt: Math.max(30, lines * 16) });
//         merges.push({
//           s: { r: currentRowIndex, c: 6 },
//           e: { r: currentRowIndex, c: 7 },
//         });
//         currentRowIndex++;
//       });

//       // Staff Total Row
//       dataRows.push([
//         "",
//         `TOTAL for ${staffName.toUpperCase()}`,
//         "",
//         "",
//         formatToHHMM(staffTotalEstimate),
//         secondsToHHMM(staffTotalTaken),
//         "",
//         "", // Changed to HH:MM helper
//       ]);
//       rowHeights.push({ hpt: 25 });
//       summaryRowIndices.push(currentRowIndex);
//       merges.push({
//         s: { r: currentRowIndex, c: 1 },
//         e: { r: currentRowIndex, c: 3 },
//       }); // Merge B, C, D
//       merges.push({
//         s: { r: currentRowIndex, c: 6 },
//         e: { r: currentRowIndex, c: 7 },
//       }); // Merge Reason block
//       currentRowIndex++;
//     });

//   // Grand Total Row
//   dataRows.push([
//     "",
//     "Total",
//     "",
//     "",
//     formatToHHMM(grandTotalEst),
//     secondsToHHMM(grandTotalTaken),
//     "",
//     "",
//   ]); // Changed to HH:MM helper
//   rowHeights.push({ hpt: 25 });
//   summaryRowIndices.push(currentRowIndex);
//   merges.push({
//     s: { r: currentRowIndex, c: 1 },
//     e: { r: currentRowIndex, c: 3 },
//   });
//   merges.push({
//     s: { r: currentRowIndex, c: 6 },
//     e: { r: currentRowIndex, c: 7 },
//   });
//   currentRowIndex++;

//   // --- BUILD TABLE 2 ROWS ---
//   const table2TitleIndex = currentRowIndex;
//   dataRows.push(["", "Client Support & Complaints", "", "", "", "", "", ""]);
//   rowHeights.push({ hpt: 30 });
//   merges.push({
//     s: { r: table2TitleIndex, c: 1 },
//     e: { r: table2TitleIndex, c: 7 },
//   });
//   currentRowIndex++;

//   const table2HeaderIndex = currentRowIndex;
//   dataRows.push([
//     "",
//     "Client Name",
//     "Issue Type",
//     "Priority",
//     "Status",
//     "Points Details",
//     "",
//     "",
//   ]);
//   rowHeights.push({ hpt: 25 });
//   merges.push({
//     s: { r: table2HeaderIndex, c: 5 },
//     e: { r: table2HeaderIndex, c: 7 },
//   }); // Merge F, G, H
//   currentRowIndex++;

//   const table2DataRowIndices = [];

//   Object.keys(groupedByClient)
//     .sort()
//     .forEach((client) => {
//       groupedByClient[client].forEach((row) => {
//         const pointsDetailsText =
//           row.NatureofQuery || row.TaskName || row.Description || "-";

//         dataRows.push([
//           "",
//           client,
//           row.QueryType || "-",
//           row.Priority || "-",
//           row.Status || "-",
//           pointsDetailsText,
//           "",
//           "",
//         ]);
//         merges.push({
//           s: { r: currentRowIndex, c: 5 },
//           e: { r: currentRowIndex, c: 7 },
//         });
//         table2DataRowIndices.push(currentRowIndex);

//         const lines = Math.ceil(pointsDetailsText.length / 55);
//         rowHeights.push({ hpt: Math.max(35, lines * 16) });
//         currentRowIndex++;
//       });
//     });

//   // --- BUILD TABLE 3 ROWS (Running Project) ---
//   dataRows.push(["", "", "", "", "", "", "", ""]); // Spacer
//   rowHeights.push({ hpt: 15 });
//   currentRowIndex++;

//   const table3TitleIndex = currentRowIndex;
//   dataRows.push(["", "Running Project", "", "", "", "", "", ""]);
//   rowHeights.push({ hpt: 30 });
//   merges.push({
//     s: { r: table3TitleIndex, c: 1 },
//     e: { r: table3TitleIndex, c: 7 },
//   });
//   currentRowIndex++;

//   const table3Header1Index = currentRowIndex;
//   dataRows.push([
//     "",
//     "Client Name",
//     "Duration Time",
//     "Points",
//     "",
//     "",
//     "",
//     "Status",
//   ]);
//   rowHeights.push({ hpt: 25 });
//   merges.push(
//     {
//       s: { r: table3Header1Index, c: 1 },
//       e: { r: table3Header1Index + 1, c: 1 },
//     }, // Merge Client Name down
//     {
//       s: { r: table3Header1Index, c: 2 },
//       e: { r: table3Header1Index + 1, c: 2 },
//     }, // Merge Duration Time down
//     { s: { r: table3Header1Index, c: 3 }, e: { r: table3Header1Index, c: 6 } }, // Merge Points right (D, E, F, G)
//     {
//       s: { r: table3Header1Index, c: 7 },
//       e: { r: table3Header1Index + 1, c: 7 },
//     }, // Merge Status down
//   );
//   currentRowIndex++;

//   const table3Header2Index = currentRowIndex;
//   dataRows.push([
//     "",
//     "",
//     "",
//     "Opening",
//     "Today Raised",
//     "Completed",
//     "Pending",
//     "",
//   ]);
//   rowHeights.push({ hpt: 25 });
//   currentRowIndex++;

//   const table3DataRowIndices = [];
//   let t3TotalOpening = 0;
//   let t3TotalRaised = 0;
//   let t3TotalCompleted = 0;
//   let t3TotalPending = 0;

//   table3Data.forEach((row) => {
//     t3TotalOpening += Number(row.Opening) || 0;
//     t3TotalRaised += Number(row.TodayRaised) || 0;
//     t3TotalCompleted += Number(row.TodayComplete) || 0;
//     t3TotalPending += Number(row.Closing) || 0;

//     dataRows.push([
//       "",
//       row.ClientName || "-",
//       "", // 2. FIX: Cleared Duration Time values to leave the column blank
//       row.Opening || 0,
//       row.TodayRaised || 0,
//       row.TodayComplete || 0,
//       row.Closing || 0,
//       row.Status || "",
//     ]);
//     rowHeights.push({ hpt: 25 });
//     table3DataRowIndices.push(currentRowIndex);
//     currentRowIndex++;
//   });

//   const table3TotalIndex = currentRowIndex;
//   dataRows.push([
//     "",
//     "Total",
//     "",
//     t3TotalOpening,
//     t3TotalRaised,
//     t3TotalCompleted,
//     t3TotalPending,
//     "",
//   ]);
//   rowHeights.push({ hpt: 25 });
//   merges.push({
//     s: { r: table3TotalIndex, c: 1 },
//     e: { r: table3TotalIndex, c: 2 },
//   }); // Merge "Total" B to C
//   currentRowIndex++;

//   // Combine all data
//   const worksheetData = [titleRow1, titleRow2, emptyRow, headers1, ...dataRows];
//   const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
//   worksheet["!merges"] = merges;
//   worksheet["!rows"] = rowHeights;

//   // ==============================================================
//   // 4. SET COLUMN WIDTHS
//   // ==============================================================
//   worksheet["!cols"] = [
//     { wch: 3 }, // A (Spacer)
//     { wch: 30 }, // B (Client Name / Project)
//     { wch: 20 }, // C (Module / Issue Type / Duration Time)
//     { wch: 15 }, // D (Assigned Staff / Priority / Opening)
//     { wch: 15 }, // E (Est Time / Status / Today Raised)
//     { wch: 15 }, // F (Comp Time / Completed)
//     { wch: 15 }, // G (Pending / Reason pt1)
//     { wch: 25 }, // H (Status / Reason pt2)
//   ];

//   // ==============================================================
//   // 5. APPLY EXACT STYLES USING XLSX-JS-STYLE
//   // ==============================================================
//   const FONT_FAMILY = "Bookman Old Style";

//   const titleStyle = {
//     font: { name: FONT_FAMILY, sz: 14, bold: true, color: { rgb: "000000" } },
//     fill: { fgColor: { rgb: "F2F2F2" } },
//     alignment: { horizontal: "center", vertical: "center" },
//   };

//   const headerStyle = {
//     font: { name: FONT_FAMILY, sz: 10, bold: true, color: { rgb: "000000" } },
//     fill: { fgColor: { rgb: "F2F2F2" } },
//     alignment: { horizontal: "center", vertical: "center", wrapText: true },
//     border: {
//       top: { style: "thin" },
//       bottom: { style: "thin" },
//       left: { style: "thin" },
//       right: { style: "thin" },
//     },
//   };

//   const dataStyle = {
//     font: { name: FONT_FAMILY, sz: 9, color: { rgb: "000000" } },
//     border: {
//       top: { style: "thin" },
//       bottom: { style: "thin" },
//       left: { style: "thin" },
//       right: { style: "thin" },
//     },
//   };

//   const summaryStyle = {
//     font: { name: FONT_FAMILY, sz: 10, bold: true, color: { rgb: "000000" } },
//     fill: { fgColor: { rgb: "E7E6E6" } },
//     border: {
//       top: { style: "thin" },
//       bottom: { style: "thin" },
//       left: { style: "thin" },
//       right: { style: "thin" },
//     },
//   };

//   const range = XLSX.utils.decode_range(worksheet["!ref"]);

//   for (let R = range.s.r; R <= range.e.r; ++R) {
//     for (let C = range.s.c; C <= range.e.c; ++C) {
//       const cellRef = XLSX.utils.encode_cell({ c: C, r: R });
//       if (!worksheet[cellRef]) worksheet[cellRef] = { t: "s", v: "" };
//       if (C === 0) continue;

//       if (R === 0 || R === table2TitleIndex || R === table3TitleIndex) {
//         worksheet[cellRef].s = titleStyle;
//       } else if (R === 1) {
//         worksheet[cellRef].s = {
//           font: { name: FONT_FAMILY, sz: 11, bold: true },
//         };
//       } else if (
//         R === 3 ||
//         R === table2HeaderIndex ||
//         R === table3Header1Index ||
//         R === table3Header2Index
//       ) {
//         worksheet[cellRef].s = headerStyle;
//       } else if (summaryRowIndices.includes(R) || R === table3TotalIndex) {
//         worksheet[cellRef].s = {
//           ...summaryStyle,
//           alignment: { horizontal: "center", vertical: "center" },
//         };
//         // Ensure "TOTAL for STAFF" aligns nicely
//         if (summaryRowIndices.includes(R) && C <= 3) {
//           worksheet[cellRef].s.alignment.horizontal = "right";
//         }
//       } else if (table2DataRowIndices.includes(R)) {
//         const isCenter = C === 2 || C === 3 || C === 4;
//         worksheet[cellRef].s = {
//           ...dataStyle,
//           alignment: {
//             horizontal: isCenter ? "center" : "left",
//             vertical: "center",
//             wrapText: true,
//           },
//         };
//       } else if (table3DataRowIndices.includes(R)) {
//         const isCenter = C > 1; // Everything except Client Name is centered
//         worksheet[cellRef].s = {
//           ...dataStyle,
//           alignment: {
//             horizontal: isCenter ? "center" : "left",
//             vertical: "center",
//             wrapText: true,
//           },
//         };
//       } else if (R > 3 && R < table2TitleIndex) {
//         // Table 1 Data alignment
//         const isCenter = C >= 4 && C <= 5;
//         worksheet[cellRef].s = {
//           ...dataStyle,
//           alignment: {
//             horizontal: isCenter ? "center" : "left",
//             vertical: "center",
//             wrapText: true,
//           },
//         };
//       }
//     }
//   }

//   // ==============================================================
//   // 6. GENERATE AND DOWNLOAD
//   // ==============================================================
//   const workbook = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(workbook, worksheet, "Progress Report");

//   const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
//   const data = new Blob([excelBuffer], {
//     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
//   });

//   saveAs(
//     data,
//     `Daily MD sir work Progress reports on ${reportDateDisplay}.xlsx`,
//   );
// };

import * as XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";
import moment from "moment-timezone";
import { formatDateTimeDisplay } from "../utils/common";

/* Ten columns, A..J.

   The sheet was eight wide until Start Time and End Time went in. "How long
   did it take" and "when was it done" are different questions, and the
   workbook could only answer the first — which is no use when what the
   morning report is really being read for is whether the day's work landed
   inside the day.

   Every row is built through sheetRow() and every merge ends at LAST_COL
   rather than a hand-counted 7, because a ten-cell row assembled by eye is
   how one table quietly ends up a column short of the others. */
const COL_COUNT = 10;
const LAST_COL = COL_COUNT - 1;

const sheetRow = (...cells) => {
  const out = cells.slice(0, COL_COUNT);
  while (out.length < COL_COUNT) out.push("");
  return out;
};

// --- HELPERS ---
const secondsToHHMM = (seconds) => {
  if (!seconds || isNaN(seconds)) return "00:00";
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
};

const formatToHHMM = (totalMinutes) => {
  if (!totalMinutes || isNaN(totalMinutes)) return "00:00";
  const h = Math.floor(totalMinutes / 60);
  const m = Math.floor(totalMinutes % 60);
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
};

/* Read through the app's own timezone helper, not moment() direct. These
   cells have to say the same o'clock as the Start Time column on the report
   screen, and that one instant is only rendered consistently by going
   through toAppTime — the workbook getting its own answer is exactly the
   bug that took five and a half hours to find last time.

   Date included, not just the clock: the report covers a range, so "11:28 AM"
   on its own does not say which day. */
const WORKBOOK_TIME = "DD.MM.YY hh:mm A";
const stamp = (value) => formatDateTimeDisplay(value, WORKBOOK_TIME, "-");

export const ExportSupportTeamExcel = (
  dataToExport,
  dateRange,
  table3Data = [],
  /* Rows from /dashboard/team-wise (sp_Sky_DashBoard_TeamWise) — one per team
     plus "No Team" and a GRAND TOTAL. Table 3 answers "which CLIENT is
     waiting"; this answers "which TEAM is holding it", which is the question
     the management report could not settle: 58 pending on Database and 10 on
     Support is a different conversation to the same 68 spread evenly.
     Optional, so a caller that passes nothing gets the report it always got. */
  teamWiseData = [],
) => {
  if (!dataToExport || dataToExport.length === 0) {
    alert("No data available to export.");
    return;
  }

  // --- DYNAMIC DATE FORMATTING ---
  let reportDateDisplay = moment().format("DD.MM.YYYY");

  if (dateRange && dateRange.startDate && dateRange.endDate) {
    const startStr = moment(dateRange.startDate).format("DD.MM.YYYY");
    const endStr = moment(dateRange.endDate).format("DD.MM.YYYY");

    if (startStr === endStr) {
      reportDateDisplay = startStr;
    } else {
      reportDateDisplay = `${startStr} to ${endStr}`;
    }
  }

  // ==============================================================
  // 1. DATA PREPARATION FOR TABLE 1 (Project & Development Status)
  // FIX: Added the row.isManuallyRaised condition to the filter
  // ==============================================================
  const completedData = dataToExport.filter((row) => {
    const status = row.Status ? row.Status.trim().toLowerCase() : "";
    const isCompleted = status === "complete" || status === "completed";

    // Only include rows that are completed AND manually raised
    return isCompleted && row.isManuallyRaised;
  });

  const groupedByStaff = {};
  let grandTotalEst = 0;
  let grandTotalTaken = 0;

  completedData.forEach((row) => {
    const staff =
      row.AssigneeName && row.AssigneeName.trim() !== ""
        ? row.AssigneeName
        : "Unassigned";
    if (!groupedByStaff[staff]) groupedByStaff[staff] = [];

    groupedByStaff[staff].push(row);
    grandTotalEst += Number(row.EstimateTime) || 0;
    grandTotalTaken += Number(row.TimeTaken) || 0;
  });

  // ==============================================================
  // 2. DATA PREPARATION FOR TABLE 2 (Client Support & Complaints)
  // ==============================================================
  const groupedByClient = {};
  dataToExport.forEach((row) => {
    console.log(row, "row--------------");

    if (row.isManuallyRaised && !row.IsSupportTeam) {
      const client = row.ClientName || row.ProjectName || "Unassigned";
      if (!groupedByClient[client]) groupedByClient[client] = [];
      groupedByClient[client].push(row);
    }
  });
  console.log(dataToExport, "dataToExport 4324242");

  // ==============================================================
  // 3. BUILD THE EXCEL ROWS, MERGES, AND DYNAMIC HEIGHTS (10 Columns, A..J)
  // ==============================================================
  const titleRow1 = sheetRow("", "Project & Development Status");
  const titleRow2 = sheetRow("", "Report Date:", reportDateDisplay);
  const emptyRow = sheetRow("");

  /* B..J. Start Time and End Time sit either side of the work rather than
     next to Estimate: read left to right the row now tells the story in
     order — what was promised, when it began, when it ended, what it cost. */
  const headers1 = sheetRow(
    "",
    "Project / Client",
    "Module / Menu",
    "Assigned Staff",
    "Estimate Time",
    "Start Time",
    "End Time",
    "Comp. Time",
    "Reason",
  );

  const dataRows = [];
  const summaryRowIndices = [];
  const merges = [
    { s: { r: 0, c: 1 }, e: { r: 0, c: LAST_COL } }, // Main Title Merge
    { s: { r: 3, c: 8 }, e: { r: 3, c: LAST_COL } }, // Table 1 Header Reason Merge (I & J)
  ];

  const rowHeights = [
    { hpt: 35 }, // Main Title
    { hpt: 20 }, // Date
    { hpt: 10 }, // Empty
    { hpt: 25 }, // Headers
  ];

  let currentRowIndex = 4; // Data starts at index 4

  // --- BUILD TABLE 1 ROWS ---
  Object.keys(groupedByStaff)
    .sort()
    .forEach((staffName) => {
      let staffTotalEstimate = 0;
      let staffTotalTaken = 0;

      groupedByStaff[staffName].forEach((row) => {
        staffTotalEstimate += Number(row.EstimateTime) || 0;
        staffTotalTaken += Number(row.TimeTaken) || 0;
        const reasonText = row.Description || row.Solution || "-";

        dataRows.push(
          sheetRow(
            "", // Col A (Spacer)
            row.ClientName || row.ProjectName || "-",
            row.SubMenuName4 ||
              row.SubMenuName3 ||
              row.SubMenuName2 ||
              row.SubMenuName ||
              row.MainMenuName ||
              row.FormName ||
              "-",
            row.AssigneeName || "-",
            row.EstimateTime ? formatToHHMM(row.EstimateTime) : "-",
            stamp(row.StartTime),
            stamp(row.EndTime),
            row.TimeTaken ? secondsToHHMM(row.TimeTaken) : "-",
            reasonText, // Col I, merged into J
          ),
        );

        const lines = Math.ceil(reasonText.length / 45);
        rowHeights.push({ hpt: Math.max(30, lines * 16) });
        merges.push({
          s: { r: currentRowIndex, c: 8 },
          e: { r: currentRowIndex, c: LAST_COL },
        });
        currentRowIndex++;
      });

      // Staff Total Row
      dataRows.push(
        sheetRow(
          "",
          `TOTAL for ${staffName.toUpperCase()}`,
          "",
          "",
          formatToHHMM(staffTotalEstimate),
          "",
          "",
          secondsToHHMM(staffTotalTaken),
        ),
      );
      rowHeights.push({ hpt: 25 });
      summaryRowIndices.push(currentRowIndex);
      merges.push({
        s: { r: currentRowIndex, c: 1 },
        e: { r: currentRowIndex, c: 3 },
      }); // Merge B, C, D
      /* Start and End get no sub-total: adding up clock times is not a
         number. Merged blank rather than left as two empty bordered cells,
         which read as a total that failed to compute. */
      merges.push({
        s: { r: currentRowIndex, c: 5 },
        e: { r: currentRowIndex, c: 6 },
      });
      merges.push({
        s: { r: currentRowIndex, c: 8 },
        e: { r: currentRowIndex, c: LAST_COL },
      }); // Merge Reason block
      currentRowIndex++;
    });

  // Grand Total Row
  dataRows.push(
    sheetRow(
      "",
      "Total",
      "",
      "",
      formatToHHMM(grandTotalEst),
      "",
      "",
      secondsToHHMM(grandTotalTaken),
    ),
  );
  rowHeights.push({ hpt: 25 });
  summaryRowIndices.push(currentRowIndex);
  merges.push({
    s: { r: currentRowIndex, c: 1 },
    e: { r: currentRowIndex, c: 3 },
  });
  merges.push({
    s: { r: currentRowIndex, c: 5 },
    e: { r: currentRowIndex, c: 6 },
  });
  merges.push({
    s: { r: currentRowIndex, c: 8 },
    e: { r: currentRowIndex, c: LAST_COL },
  });
  currentRowIndex++;

  // --- BUILD TABLE 2 ROWS ---
  const table2TitleIndex = currentRowIndex;
  dataRows.push(sheetRow("", "Client Support & Complaints"));
  rowHeights.push({ hpt: 30 });
  merges.push({
    s: { r: table2TitleIndex, c: 1 },
    e: { r: table2TitleIndex, c: LAST_COL },
  });
  currentRowIndex++;

  const table2HeaderIndex = currentRowIndex;
  dataRows.push(
    sheetRow("", "Client Name", "Issue Type", "Priority", "Status", "Points Details"),
  );
  rowHeights.push({ hpt: 25 });
  merges.push({
    s: { r: table2HeaderIndex, c: 5 },
    e: { r: table2HeaderIndex, c: LAST_COL },
  }); // Merge F..J
  currentRowIndex++;

  const table2DataRowIndices = [];

  Object.keys(groupedByClient)
    .sort()
    .forEach((client) => {
      groupedByClient[client].forEach((row) => {
        const pointsDetailsText =
          row.NatureofQuery || row.TaskName || row.Description || "-";

        dataRows.push(
          sheetRow(
            "",
            client,
            row.QueryType || "-",
            row.Priority || "-",
            row.Status || "-",
            pointsDetailsText,
          ),
        );
        merges.push({
          s: { r: currentRowIndex, c: 5 },
          e: { r: currentRowIndex, c: LAST_COL },
        });
        table2DataRowIndices.push(currentRowIndex);

        const lines = Math.ceil(pointsDetailsText.length / 55);
        rowHeights.push({ hpt: Math.max(35, lines * 16) });
        currentRowIndex++;
      });
    });

  // --- BUILD TABLE 3 ROWS (Running Project) ---
  dataRows.push(sheetRow("")); // Spacer
  rowHeights.push({ hpt: 15 });
  currentRowIndex++;

  const table3TitleIndex = currentRowIndex;
  dataRows.push(sheetRow("", "Running Project"));
  rowHeights.push({ hpt: 30 });
  merges.push({
    s: { r: table3TitleIndex, c: 1 },
    e: { r: table3TitleIndex, c: LAST_COL },
  });
  currentRowIndex++;

  const table3Header1Index = currentRowIndex;
  dataRows.push(
    sheetRow("", "Client Name", "Duration Time", "Points", "", "", "", "Status"),
  );
  rowHeights.push({ hpt: 25 });
  merges.push(
    {
      s: { r: table3Header1Index, c: 1 },
      e: { r: table3Header1Index + 1, c: 1 },
    }, // Merge Client Name down
    {
      s: { r: table3Header1Index, c: 2 },
      e: { r: table3Header1Index + 1, c: 2 },
    }, // Merge Duration Time down
    { s: { r: table3Header1Index, c: 3 }, e: { r: table3Header1Index, c: 6 } }, // Merge Points right (D, E, F, G)
    /* Status takes H..J, down both header rows. This table has no use for
       the two columns Start/End added to Table 1, and a table that stops
       short of the ones above it looks like the sheet lost its right edge. */
    {
      s: { r: table3Header1Index, c: 7 },
      e: { r: table3Header1Index + 1, c: LAST_COL },
    },
  );
  currentRowIndex++;

  const table3Header2Index = currentRowIndex;
  dataRows.push(
    sheetRow("", "", "", "Opening", "Today Raised", "Completed", "Pending"),
  );
  rowHeights.push({ hpt: 25 });
  currentRowIndex++;

  const table3DataRowIndices = [];
  let t3TotalOpening = 0;
  let t3TotalRaised = 0;
  let t3TotalCompleted = 0;
  let t3TotalPending = 0;

  table3Data.forEach((row) => {
    t3TotalOpening += Number(row.Opening) || 0;
    t3TotalRaised += Number(row.TodayRaised) || 0;
    t3TotalCompleted += Number(row.TodayComplete) || 0;
    t3TotalPending += Number(row.Closing) || 0;

    dataRows.push(
      sheetRow(
        "",
        row.ClientName || "-",
        "", // Duration Time column left blank
        row.Opening || 0,
        row.TodayRaised || 0,
        row.TodayComplete || 0,
        row.Closing || 0,
        row.Status || "",
      ),
    );
    rowHeights.push({ hpt: 25 });
    merges.push({
      s: { r: currentRowIndex, c: 7 },
      e: { r: currentRowIndex, c: LAST_COL },
    }); // Status block, under its header
    table3DataRowIndices.push(currentRowIndex);
    currentRowIndex++;
  });

  const table3TotalIndex = currentRowIndex;
  dataRows.push(
    sheetRow(
      "",
      "Total",
      "",
      t3TotalOpening,
      t3TotalRaised,
      t3TotalCompleted,
      t3TotalPending,
    ),
  );
  rowHeights.push({ hpt: 25 });
  merges.push({
    s: { r: table3TotalIndex, c: 1 },
    e: { r: table3TotalIndex, c: 2 },
  }); // Merge "Total" B to C
  merges.push({
    s: { r: table3TotalIndex, c: 7 },
    e: { r: table3TotalIndex, c: LAST_COL },
  });
  currentRowIndex++;

  /* --- BUILD TABLE 4 ROWS (Team Wise Pending) -------------------------
     Where the backlog actually sits. The procedure already returns its own
     GRAND TOTAL row, so this table does not add one up itself — two
     independently-summed totals in one sheet is how they end up disagreeing.
     The "No Team" row is left in deliberately: it is usually the biggest
     number on the page and the whole point of looking. */
  const table4TitleIndex = [];
  const table4HeaderIndex = [];
  const table4DataRowIndices = [];
  const table4TotalIndex = [];

  const teamRows = Array.isArray(teamWiseData) ? teamWiseData : [];

  if (teamRows.length > 0) {
    dataRows.push(sheetRow("")); // Spacer
    rowHeights.push({ hpt: 15 });
    currentRowIndex++;

    table4TitleIndex.push(currentRowIndex);
    dataRows.push(sheetRow("", "Team Wise Pending"));
    rowHeights.push({ hpt: 30 });
    merges.push({
      s: { r: currentRowIndex, c: 1 },
      e: { r: currentRowIndex, c: LAST_COL },
    });
    currentRowIndex++;

    /* Total and Testing are new, and they are here because the sheet grew two
       columns and this table would otherwise have stopped short of the right
       edge. Both come straight off sp_Sky_DashBoard_TeamWise, which has
       always returned them — Pending without Total gives no sense of scale,
       and Testing is the one bucket a reader would otherwise assume was
       folded into In Progress. */
    table4HeaderIndex.push(currentRowIndex);
    dataRows.push(
      sheetRow(
        "",
        "Team",
        "Members",
        "Total",
        "Pending",
        "Not Started",
        "In Progress",
        "On Hold",
        "Testing",
        "Unassigned",
      ),
    );
    rowHeights.push({ hpt: 25 });
    currentRowIndex++;

    teamRows.forEach((row) => {
      const isGrand =
        String(row.TeamName || "").toUpperCase() === "GRAND TOTAL";

      dataRows.push(
        sheetRow(
          "",
          row.TeamName || "-",
          row.MemberCount ?? 0,
          row.Total_Nos ?? 0,
          row.Pending_Nos ?? 0,
          row.NotStarted_Nos ?? 0,
          row.InProgress_Nos ?? 0,
          row.OnHold_Nos ?? 0,
          row.Testing_Nos ?? 0,
          row.Unassigned_Nos ?? 0,
        ),
      );
      rowHeights.push({ hpt: 25 });

      // The procedure's own total row gets the total styling.
      if (isGrand) table4TotalIndex.push(currentRowIndex);
      else table4DataRowIndices.push(currentRowIndex);
      currentRowIndex++;
    });
  }

  // Combine all data
  const worksheetData = [titleRow1, titleRow2, emptyRow, headers1, ...dataRows];
  const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
  worksheet["!merges"] = merges;
  worksheet["!rows"] = rowHeights;

  // ==============================================================
  // 4. SET COLUMN WIDTHS
  // ==============================================================
  /* Start Time and End Time carry "13.08.26 11:28 AM" — 17 characters — so
     they get 18 rather than the 15 the other time columns take. Too narrow
     and Excel prints ###### instead of the timestamp, which is the one
     failure mode nobody spots until the sheet is on somebody's desk. */
  worksheet["!cols"] = [
    { wch: 3 },  // A (Spacer)
    { wch: 30 }, // B (Client / Project / Team)
    { wch: 20 }, // C (Module / Issue Type / Duration Time / Members)
    { wch: 15 }, // D (Assigned Staff / Priority / Opening / Total)
    { wch: 13 }, // E (Estimate Time / Status / Today Raised / Pending)
    { wch: 18 }, // F (Start Time / Points Details / Completed / Not Started)
    { wch: 18 }, // G (End Time / Pending / In Progress)
    { wch: 13 }, // H (Comp. Time / Status / On Hold)
    { wch: 22 }, // I (Reason pt1 / Testing)
    { wch: 22 }, // J (Reason pt2 / Unassigned)
  ];

  // ==============================================================
  // 5. APPLY EXACT STYLES USING XLSX-JS-STYLE
  // ==============================================================
  const FONT_FAMILY = "Bookman Old Style";

  const titleStyle = {
    font: { name: FONT_FAMILY, sz: 14, bold: true, color: { rgb: "000000" } },
    fill: { fgColor: { rgb: "F2F2F2" } },
    alignment: { horizontal: "center", vertical: "center" },
  };

  const headerStyle = {
    font: { name: FONT_FAMILY, sz: 10, bold: true, color: { rgb: "000000" } },
    fill: { fgColor: { rgb: "F2F2F2" } },
    alignment: { horizontal: "center", vertical: "center", wrapText: true },
    border: {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    },
  };

  const dataStyle = {
    font: { name: FONT_FAMILY, sz: 9, color: { rgb: "000000" } },
    border: {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    },
  };

  const summaryStyle = {
    font: { name: FONT_FAMILY, sz: 10, bold: true, color: { rgb: "000000" } },
    fill: { fgColor: { rgb: "E7E6E6" } },
    border: {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    },
  };

  const range = XLSX.utils.decode_range(worksheet["!ref"]);

  for (let R = range.s.r; R <= range.e.r; ++R) {
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const cellRef = XLSX.utils.encode_cell({ c: C, r: R });
      if (!worksheet[cellRef]) worksheet[cellRef] = { t: "s", v: "" };
      if (C === 0) continue;

      if (
        R === 0 ||
        R === table2TitleIndex ||
        R === table3TitleIndex ||
        table4TitleIndex.includes(R)
      ) {
        worksheet[cellRef].s = titleStyle;
      } else if (R === 1) {
        worksheet[cellRef].s = {
          font: { name: FONT_FAMILY, sz: 11, bold: true },
        };
      } else if (
        R === 3 ||
        R === table2HeaderIndex ||
        R === table3Header1Index ||
        R === table3Header2Index ||
        table4HeaderIndex.includes(R)
      ) {
        worksheet[cellRef].s = headerStyle;
      } else if (
        summaryRowIndices.includes(R) ||
        R === table3TotalIndex ||
        table4TotalIndex.includes(R)
      ) {
        worksheet[cellRef].s = {
          ...summaryStyle,
          alignment: { horizontal: "center", vertical: "center" },
        };
        // Ensure "TOTAL for STAFF" aligns nicely
        if (summaryRowIndices.includes(R) && C <= 3) {
          worksheet[cellRef].s.alignment.horizontal = "right";
        }
      } else if (table2DataRowIndices.includes(R)) {
        const isCenter = C === 2 || C === 3 || C === 4;
        worksheet[cellRef].s = {
          ...dataStyle,
          alignment: {
            horizontal: isCenter ? "center" : "left",
            vertical: "center",
            wrapText: true,
          },
        };
      } else if (
        table3DataRowIndices.includes(R) ||
        table4DataRowIndices.includes(R)
      ) {
        const isCenter = C > 1; // Everything except Client Name is centered
        worksheet[cellRef].s = {
          ...dataStyle,
          alignment: {
            horizontal: isCenter ? "center" : "left",
            vertical: "center",
            wrapText: true,
          },
        };
      } else if (R > 3 && R < table2TitleIndex) {
        // Table 1 Data alignment — E..H is now Estimate, Start, End, Comp.
        const isCenter = C >= 4 && C <= 7;
        worksheet[cellRef].s = {
          ...dataStyle,
          alignment: {
            horizontal: isCenter ? "center" : "left",
            vertical: "center",
            wrapText: true,
          },
        };
      }
    }
  }

  // ==============================================================
  // 6. GENERATE AND DOWNLOAD
  // ==============================================================
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Progress Report");

  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
  });

  saveAs(
    data,
    `Daily MD sir work Progress reports on ${reportDateDisplay}.xlsx`,
  );
};
